import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#0B1228",
      "stroke-opacity": ".14",
      "stroke-width": ".5",
      d: "M22 .25C34.012.25 43.75 9.988 43.75 22S34.012 43.75 22 43.75.25 34.012.25 22 9.988.25 22 .25Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#292A2E",
      d: "M25.375 17.833c1.108 0 2.283.609 3.117 1.659-2.734 1.508-2.292 5.45.475 6.5-.375.841-.559 1.225-1.05 1.975-.684 1.05-1.65 2.35-2.859 2.366-.491.009-.808-.142-1.158-.3-.408-.183-.842-.392-1.617-.383-.775 0-1.217.2-1.625.383-.358.158-.683.309-1.183.3-1.192-.016-2.108-1.192-2.792-2.242-1.908-2.933-2.116-6.366-.933-8.2.842-1.3 2.167-2.058 3.408-2.058.667 0 1.2.192 1.708.376.467.166.909.324 1.409.324.467 0 .842-.141 1.258-.3.492-.19 1.042-.4 1.842-.4m-.175-4.166c.133.916-.242 1.825-.733 2.458-.525.683-1.442 1.217-2.325 1.183-.159-.883.25-1.791.75-2.4.558-.666 1.5-1.183 2.308-1.241"
    }, null, -1)
  ]))]))
}
export default { render: render }